import React from 'react';
import {observer} from 'mobx-react-lite';
import {useTranslation} from 'react-i18next';

import Button from './Button';
import useStore from '../stores/useStore';

import {ReactComponent as NewVersionIcon} from '../assets/icons/new-version-fill.svg';


const VersionUpdateAppBar: React.FC = observer(() => {
  const {appVersionUpdater, externalApiCallHandler} = useStore();
  const {t} = useTranslation();

  if (!appVersionUpdater.hasUpdate) {
    return null;
  }

  return (
    <div
      className="px-1 d-flex align-items-center justify-content-between justify-content-sm-center justify-content-center bg-brand-primary color-white relative z-10"
      style={{height: 'var(--update-app-top-bar-height)'}}
      data-name="version-update-app-bar"
    >
      <div className="d-flex align-items-center gap-3">
        <NewVersionIcon />
        <span className="paragraph-2 sm:paragraph-1">{t('app_version_updater_available_new_version')}</span>
      </div>
      <Button
        className="ml-5"
        color="white"
        variant="contained"
        size="small"
        onClick={
          appVersionUpdater.hasNewDesktopVersion ? externalApiCallHandler.updateDesktopApp : appVersionUpdater.update
        }
      >
        {t('app_version_updater_update_now_btn')}
      </Button>
    </div>
  );
});

VersionUpdateAppBar.displayName = 'VersionUpdateAppBar';

export default VersionUpdateAppBar;
